"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AkBarsBank = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AkBarsBank = function AkBarsBank(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.647 9.827c-.25-.648-.867-1.001-1.535-.878l-1.372.254a.43.43 0 00-.338.499.42.42 0 00.486.347l1.372-.254c.327-.06.528.14.608.348.08.207.066.495-.212.68l-2.014 1.34a.577.577 0 01-.61.024.607.607 0 01-.313-.538V7.308a.424.424 0 00-.418-.43.424.424 0 00-.419.43v4.341a1.459 1.459 0 001.436 1.476c.27 0 .539-.08.779-.24l2.014-1.34c.57-.379.786-1.07.536-1.718zm-7.085-.877l-1.372.253a.43.43 0 00-.338.5.42.42 0 00.486.346l1.372-.253c.327-.06.528.14.608.347.08.208.067.496-.212.68l-2.014 1.34a.576.576 0 01-.61.024.607.607 0 01-.312-.538V8.35c0-.549-.28-1.032-.75-1.294a1.386 1.386 0 00-1.465.058l-5.067 3.37c-.57.378-.785 1.068-.535 1.717.25.648.866 1 1.535.877l4.423-.816a.429.429 0 00.338-.499.42.42 0 00-.486-.347l-4.423.816c-.327.06-.529-.14-.608-.347-.08-.208-.067-.495.212-.68l5.065-3.37a.577.577 0 01.61-.024c.196.11.312.311.312.54v3.297a1.459 1.459 0 001.437 1.476c.27 0 .538-.08.778-.24l2.015-1.34c.57-.379.785-1.069.535-1.717-.249-.649-.866-1.001-1.534-.878z",
    fill: "#009C32"
  }));
};

exports.AkBarsBank = AkBarsBank;
var _default = AkBarsBank;
exports.default = _default;